import { Dispatch, SetStateAction, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment/moment'

import { expPaymentDateSelector } from 'features'
import { AnimateOpacity } from 'primsell-shared-layer/components'

import { useTimer, ETimerVariant } from 'hooks'

import { TimerContainer } from '../timer-container'

export interface IStripeSessionTimerProps {
  setIsPaymentSessionExpired: Dispatch<SetStateAction<boolean>>
}

const StripeSessionTimer = ({ setIsPaymentSessionExpired }: IStripeSessionTimerProps): JSX.Element | null => {
  const expPaymentDate = useSelector(expPaymentDateSelector)

  const { timeLeft, warning, timerExpired } = useTimer({
    startTime: expPaymentDate,
    variant: ETimerVariant.Primary,
    warningTime: { value: 61, type: 'seconds' },
  })

  useEffect(() => {
    const currentDateTime = new Date().getTime()
    const expPaymentDateTime = new Date(expPaymentDate || 0)?.getTime()
    if (expPaymentDateTime && currentDateTime < expPaymentDateTime) {
      const delay = expPaymentDateTime - currentDateTime
      setTimeout(() => {
        setIsPaymentSessionExpired(true)
      }, delay)
    }
  }, [expPaymentDate, setIsPaymentSessionExpired])

  const title = useMemo(() => {
    if (timerExpired) {
      return `Your session is expired. Please renew your payment details.`
    } else {
      return `Please note, that your session will expire at ${moment(expPaymentDate).format('HH:mm')}.`
    }
  }, [expPaymentDate, timerExpired])

  if (!timeLeft || !expPaymentDate) {
    return null
  }

  return (
    <AnimateOpacity>
      <TimerContainer leftString={title} rightString={`Remaining time: ${timeLeft}`} warning={warning} />
    </AnimateOpacity>
  )
}

export { StripeSessionTimer }
